import React from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { gray80 } from '../../constants/colors';

type MemberOption = {
  uid: string;
  name: string;
  email: string;
};

type Props = {
  members: MemberOption[];
  selectedUids: string[];
  onChange: (uids: string[]) => void;
};

const GroupMemberSelector: React.FC<Props> = ({ members, selectedUids, onChange }) => {
  const handleToggle = (uid: string): void => {
    if (selectedUids.includes(uid)) {
      onChange(selectedUids.filter(id => id !== uid));
    } else {
      onChange([...selectedUids, uid]);
    }
  };

  return (
    <Box>
      <Typography color={gray80} sx={{ fontSize: '14px', mb: '8px', textAlign: 'left' }}>
        メンバー
      </Typography>
      <FormGroup>
        {members.map(member => (
          <FormControlLabel
            key={member.uid}
            control={
              <Checkbox
                checked={selectedUids.includes(member.uid)}
                onChange={(): void => handleToggle(member.uid)}
                size="small"
              />
            }
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Typography sx={{ fontSize: '14px', whiteSpace: 'nowrap' }}>
                  {member.name || '(未登録)'}
                </Typography>
                <Typography sx={{ fontSize: '12px', color: gray80, whiteSpace: 'nowrap' }}>
                  {member.email}
                </Typography>
              </Box>
            }
          />
        ))}
        {members.length === 0 && (
          <Typography sx={{ fontSize: '14px', color: gray80 }}>
            招待済みの担当者がいません
          </Typography>
        )}
      </FormGroup>
    </Box>
  );
};

export default GroupMemberSelector;
